import { Icon } from '../../../common/Icon';

export function AssessmentWarning({
  warning,
}: {
  warning: string;
}): JSX.Element {
  return (
    <div className="mb-3 text-sm font-nunito w-full flex items-start gap-2 p-3 bg-[#FDFDFD] border-l-4 border-[#FA8C16] rounded shadow-sm">
      <Icon name="warning" color="#FA8C16" className="w-5 h-5 mt-0.5" />
      <span className="text-[#434343]">{warning}</span>
    </div>
  );
}
